import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';

import { useQuery } from '@tanstack/react-query';

// apiService
import RoleService from '../Roles/apiService';


const EditUser = () => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  const { data: roles, isLoading } = useQuery({
    queryKey: ['roles'],
    queryFn: () => RoleService.getRoles(),
  });

  useEffect(() => {
    if (roles) {
      const updatedFields = formFields.map(field => {
        if (field.name === 'role_id') {
          return {
            ...field,
            options: roles.map(role => ({
              value: role.role_id,
              label: role.name 
            }))
          };
        }
        return field;
      });
      setFormFields(updatedFields);
    }
  }, [roles]);

  return (
    <EditForm title={"User"} initialValues={initialValues} fields={formFields} schema={schema} loading={isLoading} url={"users"}>
      
      <Grid container spacing={3}>
       
      </Grid>
        
    </EditForm>
  );
}

export default EditUser;